import React from 'react';
import { IconProps } from '../Icons.interface';

export const CloseIcon: React.FC<IconProps & { strokeWidth?: number }> = ({
  className,
  strokeWidth = 2,
}) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.5 1.5L1.5 8.5"
      stroke="currentColor"
      strokeWidth={`${strokeWidth}`}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 1.5L8.5 8.5"
      stroke="currentColor"
      strokeWidth={`${strokeWidth}`}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
